module.exports = __webpack_public_path__ + "static/media/flo.620286ca.svg";